import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { optionsPropTypes } from './SelectPropTypes';
import Select from './Select';
import {
  clearDiscountCodeCategories,
  getDiscountCodeCategories,
} from '../../../../actions/sales/DiscountCodeCategory';

export const DiscountCodeCategorySelect = ({
  loading,
  options,
  isGridVariant,
  isMulti,
  isClearable,
  onValueChange,
  dispatchClearDiscountCodeCategories,
  dispatchGetDiscountCodeCategories,
  ...rest
}) => {
  useLayoutEffect(() => () => dispatchClearDiscountCodeCategories(), []);

  const onInputChange = (inputValue) => {
    const inputValueLength = inputValue.trim().length;

    const query = ['active:true'];

    if (inputValueLength && inputValueLength >= 4) {
      query.push(`name:${inputValue}`);
      dispatchGetDiscountCodeCategories({ query });
    }
  };

  const filterOption = (users) => users;

  return (
    <Select
      isLoading={loading}
      onInputChange={onInputChange}
      options={options}
      isMulti={isMulti}
      onValueChange={onValueChange}
      isClearable={isClearable}
      isGridVariant={isGridVariant}
      filterOption={filterOption}
      {...rest}
    />
  );
};

DiscountCodeCategorySelect.propTypes = {
  isGridVariant: PropTypes.bool,
  dispatchGetDiscountCodeCategories: PropTypes.func.isRequired,
  dispatchClearDiscountCodeCategories: PropTypes.func.isRequired,
  onValueChange: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool,
  options: optionsPropTypes,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
};

DiscountCodeCategorySelect.defaultProps = {
  isGridVariant: false,
  isMulti: false,
  options: [],
  isClearable: false,
  onValueChange: undefined,
  placeholder: 'Busca por nombre',
};

const mapStateToProps = ({ SalesUnit }) => ({
  options: SalesUnit.DiscountCodeCategory.getIn([
    'all',
    'content',
    'content',
  ]).map(({ id, name }) => ({
    value: id,
    label: name,
  })),
  loading: SalesUnit.DiscountCodeCategory.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetDiscountCodeCategories: getDiscountCodeCategories,
  dispatchClearDiscountCodeCategories: clearDiscountCodeCategories,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DiscountCodeCategorySelect);
